import { default as React, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import ExpiredTenantDialog from './ExpiredTenantDialog';
import { useAccountSubscriptions } from '../../hooks';
import RenderComponentOrLoading from '../RenderComponentOrLoading';

interface ExpiredTenantDialogWrapperProps {
	children: JSX.Element;
	expiredSubscriptionsSet?: Set<string>;
	isTenantAware?: boolean;
}
export default function ExpiredTenantDialogWrapper({
	children,
	expiredSubscriptionsSet,
	isTenantAware = true,
}: ExpiredTenantDialogWrapperProps): JSX.Element {
	const { activeSubscriptions, initialized } = useAccountSubscriptions(
		expiredSubscriptionsSet,
	);
	const featureEnabled = expiredSubscriptionsSet !== undefined;

	const [open, setOpen] = useState<boolean>(false);

	// Subscriptions-usage is now fetched by useInitialization (runDataStep);
	// this wrapper only renders the dialog based on the resolved subscriptions.
	useEffect(() => {
		const hasActiveSubscriptions = activeSubscriptions.length > 0;
		setOpen(featureEnabled && !hasActiveSubscriptions);
	}, [activeSubscriptions.length]);

	if (!isTenantAware) return <>{children}</>;

	if (open) {
		return (
			<RenderComponentOrLoading loading={!initialized}>
				<Switch>
					<Route path="/">
						<ExpiredTenantDialog
							open={true}
							loading={!initialized}
						/>
					</Route>
				</Switch>
			</RenderComponentOrLoading>
		);
	}
	return <>{children}</>;
}
